import autoBind from 'auto-bind'

import { ActionResult } from 'api/domain/app'
import { Token } from 'api/domain/auth'
import { AppApiBase } from 'api/core/AppApiBase'

class AuthApi {
  constructor(protected api: AppApiBase) {
    autoBind(this)
  }

  register(body: {
    email: string
    first_name: string
    last_name: string
    steam_trade_url?: string
  }) {
    return this.api.post<ActionResult>('/auth/register', body)
  }

  loginRequest(body: { email: string }) {
    return this.api.post<ActionResult>('/auth/login', body)
  }

  loginWithOtp(body: { email: string; otp: string }) {
    return this.api.post<Token>('/auth/otp', body)
  }

  loginWithToken(token: string) {
    return this.api.post<Token>('/auth/token', {
      token,
    })
  }

  refresh() {
    return this.api.get<Token>('/auth/refresh', undefined, {
      skipAuthRefresh: true,
    })
  }
}

export default AuthApi
